import { Link } from "react-router-dom";
import styles from "./Footer.module.css";

export default function Footer() {
  return (
    <section className={styles.footer}>
      <div className="inner">
        <ul className={styles.terms}>
          <li>
            <Link to="/terms/1">이용약관</Link>
          </li>
          <li>
            <Link to="/terms/2">개인정보처리방침</Link>
          </li>
        </ul>
        <ul className={styles.company_box}>
          <li>상호명: 주식회사 엔아이시스템</li>
          <li>대표이사: 이현봉</li>
          <li>사업자등록번호: 646-81-02517</li>
          <li>대표전화: 1666-2869</li>
          <li>이메일: sales@nisystem.co.kr</li>
          <li>주소: 경기도 성남시 중원구 갈마치로288번길 14, A동 808호 (상대원동, 성남SK-V1타워)</li>
          <li>카카오톡 채널 ID : @nisystem</li>
          <li>카카오톡 채널 URL : http://pf.kakao.com/_DxcRxmb</li>
        </ul>
        <p className={styles.copyrite}>
          Copyright ⓒ NISYSTEM. All rights reserved.
        </p>
      </div>
    </section>
  );
}
